import { render, staticRenderFns } from "./CollectionCardSlider.vue?vue&type=template&id=f02f1896&scoped=true"
import script from "./CollectionCardSlider.vue?vue&type=script&lang=js"
export * from "./CollectionCardSlider.vue?vue&type=script&lang=js"
import style0 from "./CollectionCardSlider.vue?vue&type=style&index=0&id=f02f1896&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f02f1896",
  null
  
)

export default component.exports